import SweetAlert from "react-bootstrap-sweetalert";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";

import TablePagination from "@material-ui/core/TablePagination";
import TableContainer from "@material-ui/core/TableContainer";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import AddAlert from "@material-ui/icons/AddAlert";
import TableRow from "@material-ui/core/TableRow";
import Person from "@material-ui/icons/Person";
import Close from "@material-ui/icons/Close";
import Table from "@material-ui/core/Table";
import Edit from "@material-ui/icons/Edit";
import Box from "@material-ui/core/Box";

import { PAGINATION_DETAILS, PAGE_SIZES, API_BASE_URL, CSV_DATE_FORMAT } from "../../common/constants";
import styles from "assets/jss/material-dashboard-pro-react/views/userStyle.js";
import CompanyFacilityFilter from "views/FilterBox/CompanyFacilityFilter";
import { downloadBlobFile, arrayToCsvFormat } from "common/helpers";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import CardHeader from "components/Card/CardHeader.js";
import Snackbar from "components/Snackbar/Snackbar";
import GridItem from "components/Grid/GridItem.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Loader from "components/Loader/Loader.js";
import { fetchRequest } from "common/service";
import Card from "components/Card/Card.js";

const useStyles = makeStyles(styles);

const columns = [
  { id: "name", label: "Name", minWidth: 100, sort: true },
  { id: "emailAddress", label: "Email", minWidth: 130, sort: false },
  { id: "address", label: "Address", minWidth: 170, sort: false },
  { id: "status", label: "Status", minWidth: 100, sort: true },
  { id: "createdOn", label: "Date Created", minWidth: 130, type: "date", sort: true },
  { id: "action", label: "Action", minWidth: 170, align: "right", sort: false, format: (value) => value.toFixed(2)},
];

export default function Company() {
  const history = useHistory();
  const classes = useStyles();
  const userDetails = JSON.parse(localStorage.getItem("user-details"));
  const loggedUserRole = userDetails !== null ? userDetails.roles[0].role : "";

  const [rowsPerPage, setRowsPerPage] = useState(PAGINATION_DETAILS.pageSize);
  const [page, setPage] = useState(PAGINATION_DETAILS.pageNumber);
  const [toastStatus, setToastStatus] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [orderBy, setOrderBy] = useState("createdOn");
  const [companyList, setCompanyList] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState("DESC");
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    getCompanyList();
  }, [page, orderBy, filterData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const getCompanyList = async() => {
    setLoading(true);
    const endPoint = `${API_BASE_URL}/user/supplier-advanced/?pageNumber=${page}&pageSize=${rowsPerPage}&sortBy=${orderBy}&sortOrder=${order}`;
    
    const requestBody = [];
    if (filterData.name) {
      requestBody.push({"key":"name","operator":"Like","value": filterData.name,"valueFrom":null,"valueTo":null,"isDateValue":false,"dateTimeRangeValue":null,"criteriaNumber":0,"isCustomField":false});
    }
    if (filterData.email) {
      requestBody.push({"key":"emailAddress","operator":"Like","value": filterData.email,"valueFrom":null,"valueTo":null,"isDateValue":false,"dateTimeRangeValue":null,"criteriaNumber":0,"isCustomField":false});
    }
    if (filterData.company) {
      requestBody.push({"key":"supplierId","operator":"Equal","value":filterData.company,"valueFrom":null,"valueTo":null,"isDateValue":false,"dateTimeRangeValue":null,"criteriaNumber":0})
    }
    
    const companyListData = await fetchRequest("POST", endPoint, requestBody);
    setCompanyList(companyListData || {});
    setLoading(false);
  }

  const handleFilterApply = (data) => {
    setFilterData(data);
    setPage(0);
  }

  const createSortHandler = (property) => () => {
    const isAsc = orderBy === property && order === "ASC";
    setOrder(isAsc ? "DESC" : "ASC");
    setOrderBy(property);
    setPage(0);
  };

  const warningWithConfirmMessage = (company) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={async () => {
          const endPoint = `${API_BASE_URL}/user/supplier?supplierId=${company.supplierId}`;
          const DeleteFacilityRequest = await fetchRequest("DELETE", endPoint, {},true);
          if (DeleteFacilityRequest?.response?.status === 200) {
            setAlertMessage("Company deleted successfully");
            setToastStatus(true);
            getCompanyList();
          } else {
            setAlertMessage("Failed to delete Company");
            setToastStatus(true);
          }
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        showCancel
      >
        You will not be able to recover <b>{company.name}</b> company data!
      </SweetAlert>
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const onEditButtonClick = ({ supplierId }) => {
    history.push(`/admin/edit-company/${supplierId}`);
  };

  const downloadCSVData = () => {
    if (!companyList?.content || companyList.content.length === 0) {
      alert("No data found to download");
      return;
    }

    const headers = [ "Name", "Email", "Address", "Status", "Date Created"];

    const csvData = companyList.content.map((row) => {
      // Format address from contactInfo
      let addressValue = "";
      if (row.contactInfo) {
        const { streetAddress1, streetAddress2, city, state, country, zipcode, primaryPhone, secondaryPhone } = row.contactInfo;
        const addressParts = [
          streetAddress1,
          streetAddress2,
          city,
          state,
          country,
          zipcode,
          primaryPhone,
          secondaryPhone
        ].filter(part => part && part.trim() !== "");
        addressValue = addressParts.join(", ");
      }

      return {
        "Name": row.name || "",
        "Email": row.emailAddress || "",
        "Address": addressValue,
        "Status": row.status || "",
        "Date_Created": row.createdOn ? moment(row.createdOn).format(CSV_DATE_FORMAT) : ""
      };
    });

    downloadBlobFile(
      arrayToCsvFormat(csvData, headers),
      `companies_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`,
      "text/csv;charset=utf-8;"
    );
  };

  return (<>
    <CompanyFacilityFilter hideCompanyFilter={true} onApply={handleFilterApply} />
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="danger" icon>
            <CardIcon color="danger">
              <Person />
            </CardIcon>
            {["TenantAdmin"].includes(loggedUserRole) && (
              <div style={{ marginBottom: "15px", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                <Box>
                  <Button color="primary" onClick={() => {history.push(`/admin/add-company`);}}>Create Company</Button>
                </Box>
                <Box>
                  <Button onClick={downloadCSVData} color="danger" disabled={!companyList?.content || companyList.content.length === 0}>
                    Download CSV
                  </Button>
                </Box>
              </div>
            )}
          </CardHeader>
          <CardBody>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell key={column.id} align={column.align} style={{ maxWidth: column.minWidth }}>
                        {column.sort ? (
                          <TableSortLabel onClick={createSortHandler(column.id)} style={{ maxWidth: column.minWidth, minWidth: column.minWidth}} active={orderBy === column.id} direction={orderBy === column.id ? order.toLowerCase() : "asc"}>
                            <Typography>{column.label}</Typography>
                          </TableSortLabel>
                        ) : <Typography>{column.label}</Typography>}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {companyList?.content?.map((row, index) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index + "" + row.userId}>
                        {columns.map((column) => {
                          let value = row[column.id];
                          if (column.id === "address") {
                            let { streetAddress1, streetAddress2, city, state, country, zipcode, primaryPhone, secondaryPhone } = row["contactInfo"];
                            value = `
                            ${streetAddress1 ? streetAddress1 : ""}
                            ${streetAddress2 ? streetAddress2 : ""}
                            ${city ? city : ""}
                            ${state ? state : ""} 
                            ${country ? country : ""} 
                            ${zipcode ? zipcode : ""} 
                            ${primaryPhone ? primaryPhone : ""} 
                            ${secondaryPhone ? secondaryPhone : ""}
                          `;
                          }
                          if (column.type === "date") {
                            value = moment(row[column.id]).format("DD/MM/YY hh:mm A");
                          }
                          return (
                            <TableCell key={column.id} style={{ maxWidth: column.minWidth }} align={column.align}>
                                {column.id !== "action" && column.format && typeof value === "number" ? column.format(value) : value}
                                {column.id === "action" && ["TenantAdmin"].includes(loggedUserRole) && (<>
                                    <Button color="success" simple onClick={() => { onEditButtonClick(row) }} className={classes.actionButton}><Edit /></Button>
                                    <Button color="danger" simple onClick={() => {warningWithConfirmMessage(row)}} className={classes.actionButton}><Close /></Button>
                                </>)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={PAGE_SIZES}
              component="div"
              count={companyList?.totalElements}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            <Loader status={loading} />
            {alert}
          </CardBody>
        </Card>
      </GridItem>
      <Snackbar
        place="tr"
        color="success"
        icon={AddAlert}
        message={alertMessage}
        open={toastStatus}
        closeNotification={() => setToastStatus(false)}
        close
      />
    </GridContainer>
    </>
  );
}
